import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Container, Grid, InputAdornment, Tab, Tabs, TextField, Typography } from "@mui/material"
import styleCss from "../Style/style"
import SearchIcon from '@mui/icons-material/Search'
import { Link } from "react-router-dom"
import Popularimg from "../img/faq-star.png"
import React, { useState } from "react"
import TapIcon1 from "../img/question1.png"
import TapIcon2 from "../img/question2.png"
import TapIcon3 from "../img/question3.png"
import TapIcon4 from "../img/question4.png"
import TapIcon5 from "../img/question5.png"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Doticon from '../img/red-dot.png'
import StarIcon from '../img/faq-star.png'
import IconMsg from '../img/faq-msg.png'
import LoginImg1 from '../img/newLoginimg.png'
import LoginImg2 from '../img/newLoginimg1.png'

const Viewallfaq = () => {
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [expanded, setExpanded] = React.useState('');
    const handleChange1 = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <>
            <Grid sx={styleCss.CommonTopStyle}>
                <Container>
                    <Grid Container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '20px',
                                fontWeight: 600,
                                fontStretch: 'normal',
                                textAlign: 'center',
                                color: '#1d1d1d',
                                marginBottom: '10px',
                            }}>
                                Frequently Asked Questions
                            </Typography>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '15px',
                                fontWeight: 400,
                                textAlign: 'center',
                                color: '#364252',
                                marginBottom: '10px',
                            }}>
                                Find answers to common questions about booking, payments, and more
                            </Typography>
                            <Grid
                                container
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                    marginTop: '15px',
                                }}
                            >
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder="Search FAQs (e.g., 'refund policy', 'track bus', 'safety+')"
                                    sx={{
                                        width: '50%',
                                        "@media (max-width:600px)": {
                                            width: '100%',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '6px',
                                            border: '1px solid #e5e5e5',
                                            backgroundColor: '#f3f3f5',
                                        },
                                        '& .MuiInputBase-input': {
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '14px',
                                            color: '#364252',
                                            padding: '10px',
                                        },
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment>
                                                <Link> <SearchIcon sx={{ color: '#717182', marginTop: '8px' }} /> </Link>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid Container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Typography sx={{
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '17px',
                                fontWeight: 600,
                                textAlign: 'left',
                                color: '#0e182b',
                                marginBottom: '20px',
                                marginTop: '25px',
                            }}>
                                <img src={Popularimg} alt="" style={{ verticalAlign: 'middle', marginRight: '2px' }} />  Most Popular Questions
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Grid sx={styleCss.BookBorderStyle}>
                                <Grid sx={{ display: 'flex', }}>
                                    <Grid>
                                        <img src={Popularimg} alt="" style={{ verticalAlign: 'middle', marginRight: '5px' }} />
                                    </Grid>
                                    <Grid>
                                        <Typography sx={styleCss.BooktextStyle}>
                                            How do I book a bus ticket on redBus?
                                        </Typography>
                                        <Typography sx={styleCss.BooktextStyle1}>
                                            Booking a bus ticket is simple! Enter your departure and destination cities, select your travel date...
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Grid sx={styleCss.BookBorderStyle}>
                                <Grid sx={{ display: 'flex', }}>
                                    <Grid>
                                        <img src={Popularimg} alt="" style={{ verticalAlign: 'middle', marginRight: '5px' }} />
                                    </Grid>
                                    <Grid>
                                        <Typography sx={styleCss.BooktextStyle}>
                                            How do I book a bus ticket on redBus?
                                        </Typography>
                                        <Typography sx={styleCss.BooktextStyle1}>
                                            Booking a bus ticket is simple! Enter your departure and destination cities, select your travel date...
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Grid sx={styleCss.BookBorderStyle}>
                                <Grid sx={{ display: 'flex', }}>
                                    <Grid>
                                        <img src={Popularimg} alt="" style={{ verticalAlign: 'middle', marginRight: '5px' }} />
                                    </Grid>
                                    <Grid>
                                        <Typography sx={styleCss.BooktextStyle}>
                                            How do I book a bus ticket on redBus?
                                        </Typography>
                                        <Typography sx={styleCss.BooktextStyle1}>
                                            Booking a bus ticket is simple! Enter your departure and destination cities, select your travel date...
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Grid sx={styleCss.BookBorderStyle}>
                                <Grid sx={{ display: 'flex', }}>
                                    <Grid>
                                        <img src={Popularimg} alt="" style={{ verticalAlign: 'middle', marginRight: '5px' }} />
                                    </Grid>
                                    <Grid>
                                        <Typography sx={styleCss.BooktextStyle}>
                                            How do I book a bus ticket on redBus?
                                        </Typography>
                                        <Typography sx={styleCss.BooktextStyle1}>
                                            Booking a bus ticket is simple! Enter your departure and destination cities, select your travel date...
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Grid sx={styleCss.BookBorderStyle}>
                                <Grid sx={{ display: 'flex', }}>
                                    <Grid>
                                        <img src={Popularimg} alt="" style={{ verticalAlign: 'middle', marginRight: '5px' }} />
                                    </Grid>
                                    <Grid>
                                        <Typography sx={styleCss.BooktextStyle}>
                                            How do I book a bus ticket on redBus?
                                        </Typography>
                                        <Typography sx={styleCss.BooktextStyle1}>
                                            Booking a bus ticket is simple! Enter your departure and destination cities, select your travel date...
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Grid sx={styleCss.BookBorderStyle}>
                                <Grid sx={{ display: 'flex', }}>
                                    <Grid>
                                        <img src={Popularimg} alt="" style={{ verticalAlign: 'middle', marginRight: '5px' }} />
                                    </Grid>
                                    <Grid>
                                        <Typography sx={styleCss.BooktextStyle}>
                                            How do I book a bus ticket on redBus?
                                        </Typography>
                                        <Typography sx={styleCss.BooktextStyle1}>
                                            Booking a bus ticket is simple! Enter your departure and destination cities, select your travel date...
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '35px' }}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Box
                                sx={{
                                    bgcolor: "#f0f0f0",
                                    borderRadius: "30px",
                                    padding: '8px 10px 0px',
                                    marginBottom: '30px',
                                }}
                            >
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    variant="fullWidth"
                                    sx={{
                                        "& .MuiTabs-flexContainer": {
                                            display: "flex",
                                            flexDirection: { xs: "column", sm: "row" },
                                            alignItems: { xs: "stretch", sm: "center" },
                                            gap: { xs: "10px", sm: "0px" },
                                        },
                                        "& .MuiTab-root": {
                                            textTransform: "none",
                                            borderRadius: "30px",
                                            fontWeight: 600,
                                            color: "#364252",
                                            padding: "8px 12px",
                                            minHeight: "40px",
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: "14px",
                                            height: "40px",
                                            marginBottom: { xs: '10px', sm: 0 },
                                            justifyContent: { xs: 'flex-start', sm: 'center' },
                                            "&.Mui-selected": {
                                                bgcolor: "#fff",
                                                color: "#364252",
                                                border: '1px solid #ddd',
                                            },
                                        },
                                        "& .MuiTabs-indicator": { display: "none" },
                                    }}
                                >
                                    <Tab
                                        label="All"
                                        icon={<img src={TapIcon1} alt="All" />}
                                        iconPosition="start"
                                    />
                                    <Tab
                                        label="General 8"
                                        icon={<img src={TapIcon2} alt="General" />}
                                        iconPosition="start"
                                    />
                                    <Tab
                                        label="Ticket-related 12"
                                        icon={<img src={TapIcon3} alt="Ticket" />}
                                        iconPosition="start"
                                    />
                                    <Tab
                                        label="Payment 6"
                                        icon={<img src={TapIcon4} alt="Payment" />}
                                        iconPosition="start"
                                    />
                                    <Tab
                                        label="Cancellation & Refund 10"
                                        icon={<img src={TapIcon5} alt="Refund" />}
                                        iconPosition="start"
                                    />
                                </Tabs>
                            </Box>
                            {/* Tab Panels with static content */}
                            {value === 0 && (
                                <Box
                                    sx={{
                                        bgcolor: " #fff",
                                        borderRadius: "30px",
                                        display: "block",
                                        padding: '20px',
                                        overflow: 'hidden',
                                        marginBottom: '20px',
                                        "@media (max-width:600px)": {
                                            padding: '25px 8px',
                                        },
                                    }}
                                >
                                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange1('panel1')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#364252' }} />}
                                            aria-controls="panel1d-content"
                                            id="panel1d-header"
                                        >
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid>
                                                    <img src={Doticon} alt="" style={{ verticalAlign: 'middle', marginRight: '15px' }} />
                                                </Grid>
                                                <Grid>
                                                    <Typography component="span" sx={styleCss.CommonBookStyle}>
                                                        <img src={StarIcon} alt="" style={{ verticalAlign: 'middle' }} /> How to book a bus ticket?
                                                    </Typography>
                                                    <Grid sx={{ display: 'flex' }}>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Booking
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Ticket
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                How to book
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Typography sx={styleCss.SubCommunTicket}>
                                                How to book a bus ticket?
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion expanded={expanded === 'panel2'} onChange={handleChange1('panel2')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#364252' }} />}
                                            aria-controls="panel1d-content"
                                            id="panel1d-header"
                                        >
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid>
                                                    <img src={Doticon} alt="" style={{ verticalAlign: 'middle', marginRight: '15px' }} />
                                                </Grid>
                                                <Grid>
                                                    <Typography component="span" sx={styleCss.CommonBookStyle}>
                                                        <img src={StarIcon} alt="" style={{ verticalAlign: 'middle' }} /> What is Safety+ and how does it work?
                                                    </Typography>
                                                    <Grid sx={{ display: 'flex' }}>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Safety
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Safety +
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                tracking
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Typography sx={styleCss.SubCommunTicket}>
                                                What is Safety+ and how does it work?
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion expanded={expanded === 'panel3'} onChange={handleChange1('panel3')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#364252' }} />}
                                            aria-controls="panel1d-content"
                                            id="panel1d-header"
                                        >
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid>
                                                    <img src={Doticon} alt="" style={{ verticalAlign: 'middle', marginRight: '15px' }} />
                                                </Grid>
                                                <Grid>
                                                    <Typography component="span" sx={styleCss.CommonBookStyle}>
                                                        <img src={StarIcon} alt="" style={{ verticalAlign: 'middle' }} /> Can I track my bus in real-time?
                                                    </Typography>
                                                    <Grid sx={{ display: 'flex' }}>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                tracking
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                real-time
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Bus location
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Typography sx={styleCss.SubCommunTicket}>
                                                Can I track my bus in real-time?
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion expanded={expanded === 'panel4'} onChange={handleChange1('panel4')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#364252' }} />}
                                            aria-controls="panel1d-content"
                                            id="panel1d-header"
                                        >
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid>
                                                    <img src={Doticon} alt="" style={{ verticalAlign: 'middle', marginRight: '15px' }} />
                                                </Grid>
                                                <Grid>
                                                    <Typography component="span" sx={styleCss.CommonBookStyle}>
                                                        <img src={StarIcon} alt="" style={{ verticalAlign: 'middle' }} /> Is redBus available in multiple languages?
                                                    </Typography>
                                                    <Grid sx={{ display: 'flex' }}>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Language
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Multilingual
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                HIndi
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Typography sx={styleCss.SubCommunTicket}>
                                                Is redBus available in multiple languages?
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion expanded={expanded === 'panel5'} onChange={handleChange1('panel5')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#364252' }} />}
                                            aria-controls="panel1d-content"
                                            id="panel1d-header"
                                        >
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid>
                                                    <img src={Doticon} alt="" style={{ verticalAlign: 'middle', marginRight: '15px' }} />
                                                </Grid>
                                                <Grid>
                                                    <Typography component="span" sx={styleCss.CommonBookStyle}>
                                                        <img src={StarIcon} alt="" style={{ verticalAlign: 'middle' }} /> How to book a bus ticket?
                                                    </Typography>
                                                    <Grid sx={{ display: 'flex' }}>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Booking
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Ticket
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                How to book
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Typography sx={styleCss.SubCommunTicket}>
                                                How to book a bus ticket?
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion expanded={expanded === 'panel6'} onChange={handleChange1('panel6')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#364252' }} />}
                                            aria-controls="panel1d-content"
                                            id="panel1d-header"
                                        >
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid>
                                                    <img src={Doticon} alt="" style={{ verticalAlign: 'middle', marginRight: '15px' }} />
                                                </Grid>
                                                <Grid>
                                                    <Typography component="span" sx={styleCss.CommonBookStyle}>
                                                        <img src={StarIcon} alt="" style={{ verticalAlign: 'middle' }} /> What is Safety+ and how does it work?
                                                    </Typography>
                                                    <Grid sx={{ display: 'flex' }}>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Safety
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Safety +
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                tracking
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Typography sx={styleCss.SubCommunTicket}>
                                                What is Safety+ and how does it work?
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion expanded={expanded === 'panel7'} onChange={handleChange1('panel7')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#364252' }} />}
                                            aria-controls="panel1d-content"
                                            id="panel1d-header"
                                        >
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid>
                                                    <img src={Doticon} alt="" style={{ verticalAlign: 'middle', marginRight: '15px' }} />
                                                </Grid>
                                                <Grid>
                                                    <Typography component="span" sx={styleCss.CommonBookStyle}>
                                                        <img src={StarIcon} alt="" style={{ verticalAlign: 'middle' }} /> Can I track my bus in real-time?
                                                    </Typography>
                                                    <Grid sx={{ display: 'flex' }}>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                tracking
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                real-time
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Bus location
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Typography sx={styleCss.SubCommunTicket}>
                                                Can I track my bus in real-time?
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion expanded={expanded === 'panel8'} onChange={handleChange1('panel8')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#364252' }} />}
                                            aria-controls="panel1d-content"
                                            id="panel1d-header"
                                        >
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid>
                                                    <img src={Doticon} alt="" style={{ verticalAlign: 'middle', marginRight: '15px' }} />
                                                </Grid>
                                                <Grid>
                                                    <Typography component="span" sx={styleCss.CommonBookStyle}>
                                                        <img src={StarIcon} alt="" style={{ verticalAlign: 'middle' }} /> Is redBus available in multiple languages?
                                                    </Typography>
                                                    <Grid sx={{ display: 'flex' }}>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Language
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Multilingual
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                HIndi
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Typography sx={styleCss.SubCommunTicket}>
                                                Is redBus available in multiple languages?
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion expanded={expanded === 'panel9'} onChange={handleChange1('panel9')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#364252' }} />}
                                            aria-controls="panel1d-content"
                                            id="panel1d-header"
                                        >
                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid>
                                                    <img src={Doticon} alt="" style={{ verticalAlign: 'middle', marginRight: '15px' }} />
                                                </Grid>
                                                <Grid>
                                                    <Typography component="span" sx={styleCss.CommonBookStyle}>
                                                        <img src={StarIcon} alt="" style={{ verticalAlign: 'middle' }} /> How to book a bus ticket?
                                                    </Typography>
                                                    <Grid sx={{ display: 'flex' }}>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Booking
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                Ticket
                                                            </Typography>
                                                        </Grid>
                                                        <Grid>
                                                            <Typography sx={styleCss.BookingStyle}>
                                                                How to book
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Typography sx={styleCss.SubCommunTicket}>
                                                How to book a bus ticket?
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                            )}
                            {value === 1 && (
                                <Box sx={{
                                    bgcolor: " #fff",
                                    borderRadius: "30px",
                                    display: "block",
                                    padding: '20px',
                                    overflow: 'hidden',
                                    marginBottom: '20px',
                                    "@media (max-width:600px)": {
                                        padding: '25px 8px',
                                    },
                                }}>
                                    <Typography sx={{ fontSize: "16px", color: "#717182", lineHeight: 1.5 }}>
                                        General 8
                                    </Typography>
                                </Box>
                            )}
                            {value === 2 && (
                                <Box sx={{
                                    bgcolor: " #fff",
                                    borderRadius: "30px",
                                    display: "block",
                                    padding: '20px',
                                    overflow: 'hidden',
                                    marginBottom: '20px',
                                    "@media (max-width:600px)": {
                                        padding: '25px 8px',
                                    },
                                }}>
                                    <Typography sx={{ fontSize: "16px", color: "#717182", lineHeight: 1.5 }}>
                                        Ticket-related 12
                                    </Typography>
                                </Box>
                            )}
                            {value === 3 && (
                                <Box sx={{
                                    bgcolor: " #fff",
                                    borderRadius: "30px",
                                    display: "block",
                                    padding: '20px',
                                    overflow: 'hidden',
                                    marginBottom: '20px',
                                    "@media (max-width:600px)": {
                                        padding: '25px 8px',
                                    },
                                }}>
                                    <Typography sx={{ fontSize: "16px", color: "#717182", lineHeight: 1.5 }}>
                                        Payment 6
                                    </Typography>
                                </Box>
                            )}
                            {value === 4 && (
                                <Box sx={{
                                    bgcolor: " #fff",
                                    borderRadius: "30px",
                                    display: "block",
                                    padding: '20px',
                                    overflow: 'hidden',
                                    marginBottom: '20px',
                                    "@media (max-width:600px)": {
                                        padding: '25px 8px',
                                    },
                                }}>
                                    <Typography sx={{ fontSize: "16px", color: "#717182", lineHeight: 1.5 }}>
                                        Cancellation & Refund 10
                                    </Typography>
                                </Box>
                            )}
                        </Grid>
                    </Grid>

                    <Box sx={{
                        padding: '15px',
                        borderRadius: '15px',
                        border: '1px solid #ff5714',
                        backgroundColor: '#ffefe9',
                        marginTop: '10px',
                    }}>
                        <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid size={{ md: 8, xs: 12 }}>
                                <Grid sx={{ display: 'flex' }}>
                                    <Grid>
                                        <img src={IconMsg} alt="" style={{ verticalAlign: 'middle', marginRight: '10px', }} />
                                    </Grid>
                                    <Grid>
                                        <Typography sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '14px',
                                            fontWeight: 'normal',
                                            textAlign: 'left',
                                            color: '#030213',
                                            "@media (max-width:600px)": {
                                                marginLeft: '15px',
                                            },

                                        }}>
                                            Need More Help?
                                        </Typography>
                                        <Typography sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '13px',
                                            textAlign: 'left',
                                            color: '#717182',
                                            "@media (max-width:600px)": {
                                                marginLeft: '15px',
                                            },
                                        }}>
                                            Can't find what you're looking for? Our support team is here to help 24/7
                                        </Typography>
                                    </Grid>
                                </Grid>

                            </Grid>
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Grid sx={{ display: 'flex', justifyContent: 'end', }}>
                                    <Grid>
                                        <Button variant="contained" sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '15px',
                                            fontWeight: '400',
                                            textAlign: 'center',
                                            color: '#fff',
                                            borderRadius: '6px',
                                            boxShadow: '0 4px 100px 0 rgba(0, 0, 0, 0.08)',
                                            backgroundColor: '#ff5714',
                                            textTransform: 'capitalize',
                                            padding: '7px 20px',
                                            marginRight: '15px',
                                        }}><img src={LoginImg1} alt="" style={{ verticalAlign: 'middle', marginRight: '5px' }} /> Login</Button>
                                    </Grid>
                                    <Grid>
                                        <Button variant="contained" sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '15px',
                                            fontWeight: '400',
                                            textAlign: 'center',
                                            color: '#ff5714',
                                            borderRadius: '6px',
                                            boxShadow: '0 4px 100px 0 rgba(0, 0, 0, 0.08)',
                                            backgroundColor: '#fff',
                                            textTransform: 'capitalize',
                                            padding: '6px 20px',
                                            border: 'solid 1px #ff5714',
                                        }}><img src={LoginImg2} alt="" style={{ verticalAlign: 'middle', marginRight: '5px' }} /> Contact Support</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Container >
            </Grid >
        </>
    )
}
export default Viewallfaq